var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconThreeMoreHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_three_more_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_three_more_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,5 C9.325,5 10,4.325 10,3.5 C10,2.675 9.325,2 8.5,2 C7.675,2 7,2.675 7,3.5 C7,4.325 7.675,5 8.5,5 L8.5,5 Z M8.5,6.5 C7.675,6.5 7,7.175 7,8 C7,8.825 7.675,9.5 8.5,9.5 C9.325,9.5 10,8.825 10,8 C10,7.175 9.325,6.5 8.5,6.5 L8.5,6.5 Z M8.5,11 C7.675,11 7,11.675 7,12.5 C7,13.325 7.675,14 8.5,14 C9.325,14 10,13.325 10,12.5 C10,11.675 9.325,11 8.5,11 L8.5,11 Z",
    id: "Shape",
    fill: "#5697B7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeMoreHover);
export default __webpack_public_path__ + "static/media/icon_three_more_hover.2ec6ba9b207a22bcaeaeb79daf330dba.svg";
export { ForwardRef as ReactComponent };